import { ChevronDown, User } from "lucide-react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { cn } from "../../utils/cn";
import { LogOut } from "lucide-react";
import { useLogoutUser } from "../../hooks/useLogoutUser";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../routes";
import useAuthStore from "../../store/Auth";
import { USER_ROLES_IDS } from "../../constants/common";

interface ProfileDropdownProps {
  style?: string;
}

const ProfileDropdown = ({ style }: ProfileDropdownProps) => {
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { user } = useAuthStore()

  const { logoutUser } = useLogoutUser();

  // const profileDropdownItems = useMemo(
  //   () => [...user?.n_RoleID === USER_ROLES_IDS.STAFF ? ([{
  //     icon: <User size={20} />,
  //     label: t("editProfile"),
  //     onClick: () => navigate(APP_ROUTES.EDIT_PROFILE),
  //   }]) : [],
  //   {
  //     icon: <LogOut size={20} />,
  //     label: t("logOut"),
  //     onClick: logoutUser,
  //   },
  //   ],
  //   [logoutUser]
  // );

  const profileDropdownItems = useMemo(
    () => [{
      icon: <LogOut size={20} />,
      label: t("logOut"),
      onClick: logoutUser,
    }],
    [logoutUser]
  );

  const toggleDropdown = useCallback(() => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  }, [isProfileDropdownOpen]);

  const handleClickOutside = useCallback((event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsProfileDropdownOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div ref={dropdownRef} className="dropdown dropdown-end flex items-center ">
      <div
        onClick={toggleDropdown}
        tabIndex={0}
        className={cn(
          "flex gap-x-2.5 items-center cursor-pointer relative",
          style
        )}
      >
        <div className="bg-purple-primary rounded-lg px-1 py-0 sm:px-3 sm:py-0.5 cursor-pointer">
          <ChevronDown color="white" className="w-4 md:w-8" />
        </div>
      </div>
      {isProfileDropdownOpen && (
        <ul
          tabIndex={0}
          className={cn("menu dropdown-content bg-white z-[100] md:-mr-3 max-w-max rounded min-w-[150px] md:min-w-[200px] p-3 shadow flex flex-col gap-2.5 mt-[90px] md:mt-[100px]",
            // user?.n_RoleID === USER_ROLES_IDS.STAFF ? 'mt-[110px] md:mt-[120px]' : 'mt-[90px] md:mt-[100px]'
          )}
        >
          {profileDropdownItems.map((item, index) => (
            <div
              onClick={item.onClick}
              key={index}
              className={cn("flex items-center gap-2 cursor-pointer ",
                // user?.n_RoleID === USER_ROLES_IDS.STAFF && 'last:pt-3 last:border-t last:border-gray-primary/30'
              )}
            >
              {item.icon}
              <p className="text-[#000000] font-medium text-xs md:text-base">
                {item.label}
              </p>
            </div>
          ))}
        </ul>
      )}
    </div>
  );
};

export default React.memo(ProfileDropdown);